import { render, staticRenderFns } from "./AlertsSilenced.vue?vue&type=template&id=3c9d5664&scoped=true&"
import script from "./AlertsSilenced.vue?vue&type=script&lang=js&"
export * from "./AlertsSilenced.vue?vue&type=script&lang=js&"
import style0 from "./AlertsSilenced.vue?vue&type=style&index=0&id=3c9d5664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9d5664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c9d5664')) {
      api.createRecord('3c9d5664', component.options)
    } else {
      api.reload('3c9d5664', component.options)
    }
    module.hot.accept("./AlertsSilenced.vue?vue&type=template&id=3c9d5664&scoped=true&", function () {
      api.rerender('3c9d5664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/AlertsSilenced.vue"
export default component.exports